<div class="dialog-content-wrapper">
  <div mat-dialog-content class="p-16 m-0 primary-50" fusePerfectScrollbar>
    <h2>வாக்குசாவடியை பாலின அடிப்படையில் பிரிக்க விரும்புகிறீர்களா?</h2>

    <div class="mt-12" style="text-align: center">
      <button mat-raised-button class="mr-4 green-600" (click)="submit()">
        {{ "Yes" | translate }}
      </button>
      <button mat-raised-button class="red" (click)="no()">
        {{ "No" | translate }}
      </button>
    </div>
  </div>
</div>
